import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import messages from '../steps/SelectSiteTypeStep/messages';

export function LearnAboutSiteTypesText() {
  return (
    <Typography>
      <FormattedMessage
        {...messages.CreateSiteModalText2}
        values={{
          link: (chunks) => (
            <Link
              href="https://www.2n.com/en-GB/faqs/New-site-models-Differences-and-Examples-kA0Sd000000mJjVKAU"
              rel="noopener noreferrer"
              target="_blank"
            >
              {chunks}
            </Link>
          ),
        }}
      />
    </Typography>
  );
}
